export enum 発注方法区分型 {
  オンライン = 'オンライン',
  FAX = 'FAX',
  電話 = '電話',
}

export enum 商品区分型 {
  指定なし = '指定なし',
  医薬品 = '医薬品',
  その他品 = 'その他品',
  備蓄品 = '備蓄品',
}

export enum 発注入力方法区分型 {
  商品追加 = '商品追加',
  HT追加 = 'HT追加',
  定点発注 = '定点発注',
  履歴追加 = '履歴追加',
  指定なし = '指定なし',
}

export enum 使用区分型 {
  指定なし = '指定なし',
  その他 = 'その他',
  内服薬 = '内服薬',
  注射薬 = '注射薬',
  外用薬 = '外用薬',
  歯科用薬 = '歯科用薬',
}

export interface 並び順型 {
  値: string;
  ラベル: string;
}

export const 並び順一覧: 並び順型[] = [
  {値: '指定なし', ラベル: '指定なし'},
  {値: '商品名', ラベル: '商品名'},
  {値: '規格容量', ラベル: '規格・容量'},
  {値: 'メーカー名', ラベル: 'メーカー名'},
  {値: '仕入先', ラベル: '仕入先'},
  {値: '発注日', ラベル: '発注日'},
  {値: '納品指定日', ラベル: '納品指定日'},
  {値: '商品区分', ラベル: '商品区分'},
  {値: 'データ登録者', ラベル: 'データ登録者'},
];

export enum マスタ選択区分型 {
  指定なし = '指定なし',
  医薬品 = '医薬品',
  その他品 = 'その他品',
  備蓄品 = '備蓄品',
  採用品 = '採用品',
}

export enum 採用区分型 {
  採用済 = '採用済',
  採用 = '採用',
}

export enum 商品オンライン発注可否区分 {
  発注可能 = '発注可能',
  発注不可 = '発注不可',
}

export enum 発注ステータス区分 {
  発注完了 = '発注完了',
  部分入荷済 = '部分入荷済',
  入荷完了 = '入荷完了',
  エラー = 'エラー',
  キャンセル = 'キャンセル',
}

export enum 発注未確定登録区分 {
  登録する = '登録する',
  重複確認して登録する = '重複確認して登録する',
}

export enum 発注未確定登録結果区分 {
  正常終了 = '正常終了',
  重複登録あり = '重複登録あり',
}

export enum ハンディPC発注取込区分 {
  取り込む = '取り込む',
  重複確認して取り込む = '重複確認して取り込む',
}

export enum ハンディPC発注取込結果区分 {
  正常終了 = '正常終了',
  重複登録あり = '重複登録あり',
}

export enum 発注処理方法区分 {
  発注する = '発注する',
  重複確認して発注する = '重複確認して発注する',
}

export enum 発注処理結果区分 {
  正常終了 = '正常終了',
  発注時間外 = '発注時間外',
  発注可能商品なし = '発注可能商品なし',
  重複発注商品あり = '重複発注商品あり',
  その他エラー = 'その他エラー',
}

export enum 発注重複表示区分 {
  発注未確定登録 = '発注未確定登録',
  発注確定送信 = '発注確定送信',
}
